export default {
    live: 'Live',
    over: 'Over',
    planned: 'Pending',
};
